import { ActivityTypesEnum } from "./ActivityTypesEnum";
import { AuditTimeTypeEnum } from "./AuditTimeTypeEnum";
import { DrugScheduleEnum } from "./DrugScheduleEnum ";
import { IPendingTransaction } from "./pending-transaction.interface";

export interface IAudit {
    id: number;
    createDate?: string;
    type?: AuditTypesEnum;
    status?: AuditStatusesEnum;
    details?: IAuditDetail[];
    completeDate?: string;
    containsNoneOrAllUnconfirmedNDCs?: boolean;
    lineItemsCount?: number;
    from?: string;
    to?: string;
    startDateType?: AuditTimeTypeEnum;
    endDateType?: AuditTimeTypeEnum;
    schedules?: DrugScheduleEnum[];
    inventoryLocationIDs?: string[];
    actualSchedules?: DrugScheduleEnum[];
    actualInventoryLocationIDs?: string[];
    name?: string;
}

export enum AuditTypesEnum {
    AdHoc,
    AllDrugs,
    ActiveDrugs,
    InactiveDrugs,
    NinetyDayAudit,
    BackCount,
    TotalsOnly //Similar to NinetyDayAudit
}

export enum AuditStatusesEnum {
    Pending,
    InProgress,
    Completed
}

export interface IAuditDetail {
    id: number;
    drugId: number;
    gpi?: string;
    packageNDC11Digit: string;
    friendlyName: string;
    actualCount?: number;
    initialInventoryCount?: number;
    onHand: number;
    confirmByFirstName?: string;
    confirmByLastName?: string;
    confirmationDate?: string;
    adjustments: IAdjustment[];
    notes: INote[],
    pendingTransactions?: IPendingTransaction[],
    start?: number,
    in?: number,
    out?: number,
    inventoryLocationID: string,
    inventoryLocationName: string;
    similarOnHand?: number;
}

export interface IAdjustment {
    id: number;
    adjustmentQty: number;
    activityType: ActivityTypesEnum;
    description: string;
}

export interface INote {
    id: number;
    adjustmentQty: number;
    discrepancyDetails: string;
}

export interface IAuditLocation {
    id: string;
    name: string;
}